import { DomainBackup } from "@/schemas/domain.schema";
import { cbHttp } from "./http.service";
import { z } from "zod";
import { BackupSchema } from "@/schemas/backup.schema";
import { BackupMultiSchema } from "@/schemas/backupMulti.schema";

export const backupDomain = async (data: FormData): Promise<z.infer<typeof DomainBackup>> => {
    return cbHttp.post("/api/domains/backupdomain", data);
}

export const domainBackups = async (domainID: number): Promise<z.infer<typeof BackupSchema>[]> => {
    return cbHttp.get(`/api/backups/domainbackups?domainID=${domainID}`);
}

export const GetBackups = async (): Promise<z.infer<typeof BackupSchema>[]> => {
    return cbHttp.get(`/api/backups/backups`);
}

export const backupzippingsequence = async (data: FormData): Promise<z.infer<typeof BackupMultiSchema>> => {
    return cbHttp.post("/api/domains/backupzippingsequence", data);
}
export const unzippingsequence = async (data: FormData): Promise<z.infer<typeof BackupMultiSchema>> => {
    return cbHttp.post("/api/domains/unzippingsequence", data);
}
export const backupsql = async (data: FormData): Promise<z.infer<typeof BackupMultiSchema>> => {
    return cbHttp.post("/api/domains/backupsql", data);
}
export const backuplocalcleanup = async (data: FormData): Promise<z.infer<typeof BackupMultiSchema>> => {
    return cbHttp.post("/api/domains/backuplocalcleanup", data);
}
export const transferbackup = async (data: FormData): Promise<z.infer<typeof BackupMultiSchema>> => {
    return cbHttp.post("/api/domains/transferbackup", data);
}
export const backupupdateprod = async (data: FormData): Promise<z.infer<typeof BackupMultiSchema>> => {
    return cbHttp.post("/api/domains/backupupdateprod", data);
}